type Props = {
  className?: string;
};

function FiltersIcon({ className }: Props) {
  return (
    <svg className={className} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>filter-icon</title>
      <g fill="none">
        <g>
          <g transform="translate(-70 -60) translate(70 60)">
            <circle cx="20" cy="20" r="20" fill="#F2F2F2" />
            <g fill="#428A13">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.75 5.606V4.5A.75.75 0 0 0 6 3.75H3a.75.75 0 0 0-.75.75v1.645A2 2 0 0 0 1 8v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.592l-1.46-3.65a1.75 1.75 0 0 0-1.625-1.1H9.677a1.75 1.75 0 0 0-1.625 1.1L6.75 5.606zM5.25 6v-.75h-1.5V6h1.5zm10.542 0H8.208l1.237-3.093a.25.25 0 0 1 .232-.157h4.646a.25.25 0 0 1 .232.157L15.792 6zM21 7.5H3a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h18a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5zm-9 2.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5zM6.25 14a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0zm4.5 0c0-.69.56-1.25 1.25-1.25a.75.75 0 0 0 0-1.5A2.75 2.75 0 0 0 9.25 14a.75.75 0 0 0 1.5 0z"
                transform="translate(8 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FiltersIcon;
